import React from "react";
import GenericListPage from "../../../Domain/Components/Functional/GenericListPage/GenericListPage";

function CampaignListPage(props) {
    return (
        <>
            <GenericListPage setLoggedIn={props.setLoggedIn}
                            detailsHref={"/freespin-offer/details"}
                            objectKeys={["id", "player_currency_id", "operator_game_config.internal_game_id", "amount_total", "fs_total", "fs_left", "provider_offer_id", "operator_offer_id", "status", "expiry"]}
                            columnTitles={[
                                "ID", "Player Currency ID" ,"Internal Game ID", "Amount Total", "FS Total", "FS Left", "Provider Offer ID", "Operator Offer ID", "Status", "Expiry"
                            ]}
                            pageTitle={"FreeSpin Offer"}
                            readEndpoint={"freespin-offer/read"}
                            relations={["operator_game_config"]}
                            />
        </>
    )
}

export default CampaignListPage;